module.exports = __webpack_public_path__ + "img/metric_logo_bw.67c0c6bc.png";